const InstallationBrightnessSegment = ({
  label,
  levels,
  value,
  onChange,
  disabled,
}) => {
  return (
    <div className="installation-brightness-segment">
      <span className="installation-brightness-segment-label">{label}</span>
      <div
        className="installation-brightness-segment-options"
        role="group"
        aria-label={label}
      >
        {levels.map((level) => (
          <button
            key={`${label}-${level.value}`}
            type="button"
            className={
              value === level.value
                ? "installation-brightness-segment-option installation-brightness-segment-option-active"
                : "installation-brightness-segment-option"
            }
            onClick={() => onChange(level.value)}
            disabled={disabled}
            aria-pressed={value === level.value}
          >
            {level.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default InstallationBrightnessSegment;
